import styled from 'styled-components'

import { SR_ONLY } from 'styles'

export const ScreenReaderText = styled.p`
	${SR_ONLY}
`
